import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

import { Routes, Route } from "react-router-dom";

import Home from './components/pages/Home';
import Products from './components/pages/Products';
import Kontakt from './components/pages/Kontakt';
import Menu from './components/pages/Menu';
import Gallery from './components/pages/Gallery';

export default function App() {
  return (
    <>
      <Navbar />
      {/* The main tag helps browsers understand where the content is.
          The CSS class ensures the footer stays at the bottom.
      */}
      <main className="page-content">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path='/kontakt' element={<Kontakt />} />
          <Route path='/menu' element={<Menu />} />
          <Route path='/products' element={<Products />} />
          <Route path='/gallery' element={<Gallery />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}